module.exports = __webpack_public_path__ + "static/media/motivation.a679d6bd.png";